import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    report: null,
    reports: null,
    reportFranchises: null,  
    reportApplications: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const reportReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.REPORT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.REPORT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.REPORT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default reportReducer;
